import React, { useState, useContext, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import AuthContext from "../../context/Auth/AuthContext";
import { useTranslation } from 'react-i18next';
import { validate_login } from './login_validations.js';
import Notifications, { ERROR_NOTIFICATION } from '../../helpers/notifications';
import "./login.css";
const Login = () => {
    const { t } = useTranslation('common');

    const { login, is_login, is_firstime } = useContext(AuthContext);

    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')

    const history = useHistory();


    useEffect(() => {
        if (is_login()) {
            if (is_firstime()) {
                history.push('/FirstTime');
            } else {
                history.push('/AuthInstitutions');
            }

        }
    }, [history, is_login, is_firstime])

    const signin = () => {
        const error = validate_login(email, password, t);
        if (error.length === 0) {
            login(email, password, () => {
                if (is_firstime()) {
                    history.push('/FirstTime');
                } else {
                    history.push('/AuthInstitutions');
                }
            });
        } else {
            Notifications.notify(error, ERROR_NOTIFICATION)
        }

    };

    return !is_login() && (

        <div className="container-fluid">
            <div className="row login-row">
                <div className="col-lg-6 login-container">
                    <div className="container-fluid" style={{ paddingLeft: "10px" }}>
                        <div className="row">
                            <div className="col-md-10" dangerouslySetInnerHTML={{ __html: t('login.description_title') }}></div>
                        </div>
                        <div className="row">
                            <div className="col-md-10" dangerouslySetInnerHTML={{ __html: t('login.description_1') }}></div>
                        </div>
                        <div className="row">
                            <div className="col-md-10" dangerouslySetInnerHTML={{ __html: t('login.description_2') }}></div>
                        </div>
                        {/* <div className="row">
                            <div className="col-md-10" dangerouslySetInnerHTML={{ __html: t('login.description_3') }}></div>
                        </div> */}
                    </div>
                </div>

                <div className="col-lg-6 login-container login-container-right">

                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="row ilo_login_input_container">
                                    <div className="col-xs-7 col-sm-7 col-md-3 col-lg-3 col-xl-3 login-label-container">
                                        <label className="ilo_lbl_general labelLogin control-label">{t('login.email')}</label>
                                    </div>
                                    <div className="col-xs-7 col-sm-7 col-md-5 col-lg-5 col-xl-4 ilo_login_input">
                                        <input
                                            type="email" className="form-control ilo-input"
                                            placeholder={t('login.emailExample')}
                                            onKeyPress={event => { if (event.key === 'Enter') { signin() } }}
                                            onChange={(e) => { setEmail(e.target.value) }}
                                            value={email}
                                        />
                                    </div>

                                </div>
                                <div className="row ilo_login_input_container">
                                    <div className="col-xs-7 col-sm-7 col-md-3 col-lg-3 col-xl-3 login-label-container">
                                        <label className=" ilo_lbl_general labelLogin control-label">{t('login.password')}</label>
                                    </div>
                                    <div className="col-xs-7 col-sm-7 col-md-5 col-lg-5 col-xl-4 ilo_login_input">
                                        <input
                                            type="password"
                                            className="form-control ilo-input"
                                            placeholder={t('login.password')}
                                            onKeyPress={event => {
                                                if (event.key === 'Enter') {
                                                    signin()
                                                }
                                            }}
                                            onChange={(e) => {
                                                setPassword(e.target.value)
                                            }}
                                            value={password}
                                        />
                                    </div>
                                </div>
                                <div className="row ilo_login_input_container">
                                    <div className="col-xs-7 col-sm-7 col-md-8 col-lg-8 col-xl-7 psw_login_btn">
                                        <button onClick={signin} type="submit" className="btn btn-primary ilo-btn">
                                            {t('login.loginBtn')}
                                        </button>
                                    </div>
                                </div>
                                <div className="row ilo_login_input_container">
                                    <div className="col-xs-7 col-sm-7 col-md-8 col-lg-8 col-xl-7 login-option">
                                        <Link to="/ForgotPassword">{t('login.forgotPassword')}</Link>
                                    </div>
                                </div>
                                {/* <div className="row ilo_login_input_container login-changepw-container">
                                    <div className="col-xs-7 col-sm-7 col-md-8 col-lg-8 col-xl-7 login-option login-changepw-link">
                                        <Link to="/ChangePassword">{t('login.changePassword')}</Link>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </div>
    )
};

export default Login;
